<template>
  <v-menu
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    dense
    min-width="290px"
    :close-on-content-click="closeOnContentClick"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="formattedDate"
        :label="title"
        :disabled="disabled"
        :filled="filled"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :placeholder="placeholder"
        clearable
        dense
        readonly
        outlined
        v-on="on"
        @input="$emit('input', $event)"
      />
    </template>
    <v-date-picker
      v-model="date"
      color="primary"
      no-title
      locale="uk"
      dense
      :type="type"
      outlined
      @change="$emit('input', $event)"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
moment.locale("uk");

export default {
  props: {
    label: {
      type: String,
      default: "Дата",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    filled: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "date",
    },
    defaultValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    menu: false,
    date: "",
    dateViewFormats: {
      month: "MMMM YYYY",
      date: "DD.MM.YY",
    },
    dateFormats: {
      month: "YYYY-MM",
      date: "YYYY-MM-DD",
    },
  }),
  computed: {
    formattedDate() {
      const format = this.dateViewFormats[this.type];
      return this.date && moment(this.date).format(format);
    },
    title(){
      if (this.required){
        return `${this.label}*`;
      } else {
        return this.label;
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val !== this.date) {
          this.date = val;
        }
      },
      immediate: true,
    },
    defaultValue: {
      handler(val) {
        if (val) {
          const format = this.dateFormats[this.type];
          this.date = moment().format(format);
          this.$emit("input", this.date);
        }
      },
      immediate: true,
    },
  },
};
</script>